import { Button, Icon } from '@aqarmap/aqarmap-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ValuationTypeEnum } from '~/constants/enums/valuationEnums';
import { useFullRoutes } from '~/hooks';

const Header = ({ valuationType }: { valuationType: string }) => {
  const { t } = useTranslation('app');
  const { VALUATION_URL } = useFullRoutes();
  const navigate = useNavigate();

  return (
    <div className="flex justify-between items-center">
      <p className="text-title_3">{t('valuationReport')}</p>
      <div className="flex gap-2x md:gap-3x">
        {valuationType === ValuationTypeEnum.PORTFOLIO ? (
          <Button
            variant="primary"
            size="medium"
            Icon={<Icon name="folder" size="24px" />}
            className="px-x py-x md:px-3x md:py-x"
            onClick={() =>
              navigate(
                `${VALUATION_URL.MY_VALUATIONS}?valuation-type=${String(valuationType).toLowerCase()}`,
              )
            }
          >
            <span className="hidden md:inline">{t('portfolio')}</span>
          </Button>
        ) : (
          <Button
            variant="primary"
            size="medium"
            Icon={<Icon name="evaluate-property" size="24px" />}
            className="px-x py-x md:px-3x md:py-x"
            onClick={() =>
              navigate(
                `${VALUATION_URL.MY_VALUATIONS}?valuation-type=${String(valuationType).toLowerCase()}`,
              )
            }
          >
            <span className="hidden md:inline">{t('valuations')}</span>
          </Button>
        )}
        <Button
          size="medium"
          variant="secondary"
          Icon={<Icon name="plus" size="24px" />}
          className="px-x py-x md:px-3x md:py-x"
          onClick={() => navigate(VALUATION_URL.ADD)}
        >
          <span className="hidden md:inline">{t('addNewValuation')}</span>
        </Button>
      </div>
    </div>
  );
};

export default Header;
